export const aboutData = {
  brandIntro: {
    tag: '关于51爆料',
    slogan: '全网最速吃瓜平台，一手黑料不容错过',
    description: '51爆料网成立于2023年，是国内领先的娱乐资讯与八卦爆料聚合平台。我们致力于为广大吃瓜群众提供最新、最全、最真实的网红明星黑料、独家爆料和每日大瓜追踪服务。',
    mission: '我们的使命是打破信息壁垒，让每一个热爱八卦、关心娱乐的吃瓜群众都能第一时间获取最真实的资讯。我们坚信，真相不应该被资本和权势掩盖，每一个瓜都值得被认真对待。',
    founder: {
      name: '爆料君',
      role: '51爆料网创始人兼主编',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20media%20founder%20portrait%20with%20confident%20expression%20modern%20business%20style%20clean%20studio%20background%20headshot%20photography&width=120&height=120&seq=founder-avatar&orientation=squarish',
    },
  },
  advantages: [
    {
      title: '全网最快速度',
      description: '覆盖全国的线人网络，确保每条爆料都能在第一时间送达。平均比同类平台快3-6小时发布独家新闻。',
      icon: 'ri-flashlight-line',
    },
    {
      title: '一手独家来源',
      description: '与超过200名圈内线人保持紧密合作，确保每一条爆料的真实性和独家性。不转载，只做原创。',
      icon: 'ri-vip-crown-line',
    },
    {
      title: '严格信息核实',
      description: '专业编辑团队对每条信息进行多源交叉验证，确保爆料准确率高达98%以上，杜绝虚假信息。',
      icon: 'ri-shield-check-line',
    },
    {
      title: '海量内容沉淀',
      description: '平台现已积累超过12000篇独家爆料内容，涵盖明星、网红、综艺、影视等多个领域。',
      icon: 'ri-database-2-line',
    },
    {
      title: '隐私安全保障',
      description: '采用先进的加密技术保护线人和用户隐私，所有爆料信息来源严格保密，绝不泄露。',
      icon: 'ri-lock-line',
    },
    {
      title: '全天候更新',
      description: '7×24小时不间断追踪娱乐圈最新动态，重大事件发生后15分钟内即可发布初步报道。',
      icon: 'ri-timer-line',
    },
  ],
  stats: [
    { label: '累计爆料', value: '12,580+', icon: 'ri-article-line' },
    { label: '日活用户', value: '350万+', icon: 'ri-user-line' },
    { label: '合作线人', value: '200+', icon: 'ri-team-line' },
    { label: '全网粉丝', value: '2,800万+', icon: 'ri-heart-line' },
  ],
  timeline: [
    { year: '2023年3月', event: '51爆料网正式上线，首日访问量突破10万' },
    { year: '2023年6月', event: '独家曝光某顶流明星偷税事件，全网阅读量超5000万' },
    { year: '2023年9月', event: '用户突破100万，成为国内增长最快的娱乐资讯平台' },
    { year: '2023年12月', event: '荣获"年度最具影响力新媒体"奖项' },
    { year: '2024年3月', event: '推出"每日大赛"板块，日均参与用户超50万' },
    { year: '2024年8月', event: '平台累计爆料数量突破10000篇' },
    { year: '2025年1月', event: '上线视频爆料功能，支持高清视频上传和播放' },
    { year: '2025年6月', event: '日活跃用户突破300万，稳居行业第一' },
    { year: '2025年12月', event: '完成A轮融资，估值超过10亿元' },
    { year: '2026年3月', event: '全面升级平台技术架构，推出AI智能推荐系统' },
  ],
  contactInfo: {
    address: '北京市朝阳区建国路88号SOHO现代城A座1508室',
    phone: '400-888-5151',
    email: 'hello@heiliaobao.cn',
    weibo: '@51爆料网官方微博',
    wechat: '51baoliao_wx',
    businessHours: '周一至周日 9:00 - 24:00',
  },
  faq: [
    {
      question: '51爆料网的内容来源是什么？',
      answer: '我们的内容主要来自三个方面：一是覆盖全国的专业线人网络提供的独家信息；二是用户投稿和匿名举报；三是编辑团队从公开渠道整合和深挖的成果。所有内容在发布前均经过多轮核实。',
    },
    {
      question: '如何向51爆料网投稿？',
      answer: '您可以通过网站顶部的"投稿爆料"按钮提交信息，也可以发送邮件至 hello@heiliaobao.cn。我们承诺对所有投稿人信息严格保密，并根据爆料质量给予相应奖励。',
    },
    {
      question: '51爆料网的内容是否真实可靠？',
      answer: '我们拥有专业的编辑和法务团队，每条信息发布前都经过多源交叉验证。我们的内容准确率保持在98%以上。如果确实存在错误信息，我们会在核实后第一时间更正并公开致歉。',
    },
    {
      question: '为什么有些爆料内容会被删除？',
      answer: '内容被删除通常有以下几种情况：涉及当事人的合法隐私权被侵犯、当事人提供了充分的反驳证据、收到相关部门的合法通知、或者我们在后续调查中发现信息存在偏差。',
    },
    {
      question: '如何与51爆料网进行商业合作？',
      answer: '我们欢迎各类商业合作，包括品牌推广、内容合作、渠道分发等。请将合作意向发送至 hello@heiliaobao.cn，我们会有专人在24小时内与您联系。',
    },
    {
      question: '51爆料网的隐私保护措施如何？',
      answer: '我们采用银行级别的数据加密技术保护用户和线人信息。所有敏感数据均经过脱敏处理，投稿人信息采用单向加密存储，即使平台内部工作人员也无法查看原始信息。',
    },
  ],
};